/**
 * Customer-portal messages — German (reference language). Filled in
 * incrementally as views are migrated (Phase 5).
 */
const de = {};

export type Messages = typeof de;
export default de;